<template>
  <div class="badge" :class="[level]" :style="{fontSize: `${fontSize}px`}">{{text}}</div>
</template>

<script>
export default {
  props: {
    level: {default: 'low'},
    text: {default: 'VIP'},
    fontSize: {default: 12}
  },
  data () {
    return {

    }
  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
.badge {
  width: 40px;
  height: 16px;
  border: 1px solid rgba(255, 255, 255, 1);
  background: linear-gradient(
    -62deg,
    rgba(194, 148, 132, 1) 0%,
    rgba(241, 217, 201, 1) 100%
  );
  color: #fff;
  border-radius: 7px;
  font-size: 10px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;

  &.high {
    background: #17150f;
    color: #e2c495;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/widgets/vipBadge.vue